<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM v-if="r.program_name">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-chip color="secondary" 
                    label x-small style="text-transform:uppercase;" 
                    v-if="r.program_name && r.program_name.slug"
                  >{{r.program_name.slug}}</v-chip>
                  <v-progress-circular indeterminate v-if="!r.program_name || !r.program_name.slug" color="primary"></v-progress-circular>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.country_name && r.country_name.slug"
                >{{r.country_name.slug}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.program_name && r.program_name.slug"
                >{{r.program_name.slug}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span class="px-1" v-bind="attrs" v-on="on">{{r.name}}</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-if="r.multiple" dark v-bind="attrs" v-on="on" size="14" color="red">mediation</v-icon>
                  </template>
                  <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                    <v-icon dark size="18">mediation</v-icon> {{i18n.duplicate}}
                  </span>
                </v-tooltip>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.email}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.phone}}</div>
                <div :class="`${arabic?'arFont':'enFont'} pa-0`">
                  {{r.aramcco_code}}
                </div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" PHONE>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{r.phone}}
                  <v-icon color="success" size="14" v-if="r.sms_sent" v-bind="attrs" v-on="on">
                    done_all
                  </v-icon>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.name}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.email}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" DATETIME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-if="r.created_at">
                  <v-icon size="10">date_range</v-icon>
                  {{r.created_at.split('T')[0]}} |
                  <v-icon size="10">schedule</v-icon>
                  {{r.created_at.split('T')[1].split('.')[0]}}</span>
              </template>
              <div class="text-center">
                <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{getFormat(r.created_at)}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`" EDITBUTTON>
            <div class="d-flex justify-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="primary" 
                    :disabled="r.lock" v-if="!match"
                    x-small @click.stop="edit(r)">
                    <v-icon left size="12">create</v-icon>
                    {{i18n.editIconTooltip}}
                  </v-btn>
                </template>
                <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                  {{i18n.editIconTooltip}}
                </span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" color="blue" dark 
                    :disabled="r.lock" v-if="!match"
                    x-small @click.stop="$emit('selectCandidateForDetails', r)">
                    <v-icon left size="12">visibility</v-icon>
                    {{i18n.detailsIconTooltip}}
                  </v-btn>
                </template>
                <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                  {{i18n.detailsIconTooltip}}
                </span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" color="orange" dark 
                    :disabled="r.lock" v-if="!match"
                    x-small @click.stop="$emit('printCandidate', r)">
                    <v-icon left size="12">print</v-icon>
                    Print
                  </v-btn>
                </template>
                <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                  Print
                </span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="3" v-for="(key, det) in resourceKeys.map(x=>x.fetched)" :key="'details'+det"
            :class="`${arabic?'arFont':'enFont'} pa-0`">
            <div style="font-size:9px;font-weight:700;text-transform:uppercase;">{{i18n[key]}}</div>
            <div style="font-size:12px;"
              v-if="key && !key.includes('_name')"
              v-clipboard:copy="r[key]"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{r[key]}}
              
            </div>
            <div style="font-size:12px;"
              v-if="key && key.includes('_name') && r[key]"
              v-clipboard:copy="i18n[r[key].slug]"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{ r[key].slug ? i18n[r[key].slug] : r[key].name }}
            </div>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0`">
            <div style="font-size:9px;font-weight:700;text-transform:uppercase;">{{ i18n.last_login_at }}</div>
            <div style="font-size:12px;"
              v-clipboard:copy="r.last_login_at"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{ r.last_login_at ? r.last_login_at : i18n.never_logged_in }}
            </div>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0`">
            <div style="font-size:9px;font-weight:700;text-transform:uppercase;">{{ i18n.reference }}</div>
            <div style="font-size:12px;"
              v-clipboard:copy="r.last_login_at"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{ r.reference }}
            </div>
          </v-col>
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0 pt-2 text-center`">
            <v-btn color="success" class="mr-2"
              x-small @click.stop="resendEmail(r)">
              <v-icon left size="12">refresh</v-icon>
              <span class="mr-1">Resend email</span>
              <ExpirationCountDown :candidate="r" @expired="expired" />
            </v-btn>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  v-bind="attrs" 
                  v-on="on" 
                  color="secondary" 
                  :disabled="r.lock"
                  class="mr-2"
                  x-small
                  @click.stop="() => getLogs(r.id)"
                >
                  <v-icon left size="12">history</v-icon>
                  Logs
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                Logs
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" 
                  :disabled="r.lock"
                  x-small @click.stop="edit(r)">
                  <v-icon left size="12">create</v-icon>
                  {{i18n.editIconTooltip}}
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                {{i18n.editIconTooltip}}
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
import ExpirationCountDown from './expirationCountDown.vue';
export default {
  props: ["resourceSettings", "resource", "resourceKeys", "match"],
  methods: {
    expired(candidate) {
      this.deleteCookie(`last-resent-at-${candidate.id}`)
    },
    deleteCookie(name) {
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ")
              c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
              return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    resendEmail(candidate) {
      this.$emit("resendEmail", candidate);
    },
    getLogs(id) {
      this.$emit("getLogs", id);
    },
    updateResource(newResource) {
        this.$emit("updateResource", newResource);
    },
    getColor(status) {
      if(status == 'new') {
        return 'success'
      } else
      if(status == 'to_create') {
        return '#9c27b0'
      } else
      if(status == 'confirmed') {
        return 'primary'
      } else
      if(status == 'interview') {
        return '#8bc34a'
      } else
      if(status == 'accepted') {
        return '#00bcd4'
      } else
      if(status == 'need_follow_up' || status == 'out_of_reach') {
        return "#FFC107"
      } else {
        return 'error'
      }
    },
    edit(r) {
      this.$emit('editLead', r)
    },
    getFormat(d) {
        return format(d);
    },
    clipboardSuccessHandler({ value, event }) {
        this.$emit("copyS", { value, event });
    },
    clipboardErrorHandler({ value, event }) {
        this.$emit("copyF", { value, event });
    },
  },
  computed: {
    i18n() {
        return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
        if (this.$store.state.language == "ar")
            return true;
    },
    user() {
      return this.$store.state.user;
    },
  },
  components: { ExpirationCountDown }
}
</script>

<style>

</style>